<template>
    <div class="page-content eye-pdf mb-60">
        <div class="center-text own-title mb-10">
            BOSS
        </div>
        <div class="arrow-left mb-20">
            <router-link :to="{ path: '/elevale-young-entreprenuers' }">
            <!-- <a href="/elevale-young-entreprenuers"> -->
                <img :src="'images/mpower/eye/back-arrow.png'" />
            </router-link>
        </div>
        <div class="caption round-medium mb-40 card">
            <img class="eye-img" :src="'images/mpower/eye/boss.png'" />
        </div>
        <div class="content">
            <a class="eye-button button-center-medium" :href="'images/mpower/eye/BOSS_Program_2022.pdf'" download>
                Download Brochure
            </a>
        </div>
        <div class="custom-divider"></div>
    </div>
</template>
<style scoped>
.mb-20 {
    margin-bottom: 20px !important;
}
.mb-40 {
    margin-bottom: 40px !important;
}
.mb-60 {
    margin-bottom: 60px !important;
}
.arrow-left {
    margin-left: 5%;
}
.eye-img {
    max-width: 90%;
    margin: 0 auto;
}
.eye-button {
    background : rgba(255, 197, 97, 1);
    border-radius : 19px;
    width: 50%;
    margin: 0 auto;
    padding: 10px 10px;
    color: #1F1F1F;
    font-size: 14px;
    font-weight: bold;
}
</style>
<script>
export default {
    name: 'Eye_pdf'
}
</script>
